import { useState, useEffect } from 'react'
import {
  Alert,
} from 'react-bootstrap'
import Calendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import { isFuture, parseISO } from 'date-fns'
import { useNavigate } from 'react-router-dom'
import EventView from './EventView'
import useResident from '../hooks/useResident'
import useIsAdmin from '../hooks/useIsAdmin'
import useLocalStorage from '../hooks/useLocalStorage'

import '@fullcalendar/common/main.css'
import './styles.scss'

const eventClassNames = (event) => {
  const classNames = []
  const { confirmed, myBooking, officialUse } = event.event.extendedProps

  if (officialUse) {
    classNames.push('official-use')
  } else {
    if (confirmed) {
      classNames.push('booked')
    } else {
      classNames.push('requested')
    }
  }

  if (myBooking) {
    classNames.push('my-booking')
  }

  return classNames
}

const Schedule = ({ bookings }) => {
  const { getBoolean, setBoolean } = useLocalStorage()
  const navigate = useNavigate()
  const { resident } = useResident()
  const admin = useIsAdmin()
  const [showTip, _setShowTip] = useState(!getBoolean('schedule_hide_tip'))
  const [warning, setWarning] = useState('')

  const setShowTip = (val) => {
    setBoolean('schedule_hide_tip', true)
    _setShowTip(val)
  }

  useEffect(() => {
    //message.info('Click on a date you want to book.', 2)
  }, [])

  const events = bookings.map((booking) => (
    {
      date: booking.date,
      title: booking.official_use ? booking.title : (booking.confirmed ? "Booked" : "Requested"),
      //backgroundColor: 'red',
      extendedProps: {
        bookingId: booking.id,
        confirmed: booking.confirmed,
        myBooking: booking.my_booking,
        officialUse: booking.official_use,
        officialUseZoom: booking.official_use_zoom,
        title: booking.title,
      }
    }
  ))

  const handleDateClick = ({ dateStr }) => {
    if (!resident) {
      setWarning("You must complete the sign up before you can book a date.")
      return
    }

    if (events.findIndex((e) => (e.date === dateStr) && !e.extendedProps.officialUseZoom) === -1) {
      if (isFuture(parseISO(`${dateStr} 23:59:59`))) {
        navigate(`/book/${dateStr}`)
      } else {
        setWarning("You cannot book a date in the past.")
      }
    } else {
      setWarning("There is already a booking on this day.")
    }
  }

  return (
    <>
      {showTip && (
        <Alert variant="info" dismissible onClose={() => setShowTip(false)}>
          <i className="fa fa-info-circle" /> Click on a date you want to book.
        </Alert>
      )}

      {warning && (
        <Alert variant="warning" dismissible onClose={() => { setWarning('') }}>
          {warning}
        </Alert>
      )}

      <Calendar
        plugins={[dayGridPlugin, interactionPlugin]}
        events={events}
        dateClick={handleDateClick}
        eventContent={(props) => (<EventView {...props} isAdmin={admin} />)}
        eventClassNames={eventClassNames}
      />
    </>
  )
}
export default Schedule
